import {
	observer
} from 'mobx-react';
import {
	WeaBrowser
} from 'ecCom';
import Form from './Form';
import Tab from './Tab';
import Table from './Table';

@observer
export default class Content extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			store
		} = this.props, {
			exportBrowserRef
		} = store;

		this.refs.browser && exportBrowserRef(this.refs.browser);
	}

	render() {
		const {
			store
		} = this.props, {
			hasTab,
			tab,
			pageForm,
			BROWSER,
		} = store, {
			selectedKey
		} = tab;

		let c;
		if (selectedKey === '0') {
			c = <Form datas={pageForm}/>;
		} else {
			c = (
				<div>
					<Table store={store}/>
					<div className='hidden'>
						<WeaBrowser 
							{...BROWSER}
						/>
					</div>
				</div>
			);
		}

		return (
			<div>
				{
					hasTab && <Tab store={store} />
				}
				{c}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/group/Content.js